import { useAppSelector } from "../../app/hooks";
import { MenuItem, FormControl, InputLabel, Select, SelectChangeEvent, FormHelperText } from "@mui/material";
import { TransactionErrorCategoryModel } from "../../gql-types.generated";
import { selectTransactionErrorCategoryList } from "../../features/EDIContainer/EDIContainerSlice";
import { BlankMenuItem } from "../../util/SharedStyles";

interface ErrorCategoryFieldProps {
    disabled?: boolean;
    value?: string;
    displayHelpText?: boolean;
    onChange: (categoryId?: string) => void;
}

const ErrorCategoryField: React.FC<ErrorCategoryFieldProps> = props => {
    const { disabled, value, displayHelpText=false, onChange } = props;

    const categories = useAppSelector(selectTransactionErrorCategoryList);
    
    const onCategoryChange = (event: SelectChangeEvent<string | null>) => {
        const selectedValue = event.target.value;
        onChange(selectedValue?.length ? selectedValue : undefined);
    };

    const getCategoryOptions = () => {
        if (categories && categories.length) {
            let items = [];
            const blankItem = <BlankMenuItem key="0" value={''}></BlankMenuItem>;
            const dynamicItems = categories.map((category: TransactionErrorCategoryModel) => (
                <MenuItem
                    key={category.id}
                    value={category.id}
                >
                {category.name}
                </MenuItem>
            ));
            items.push(blankItem);
            items.push(...dynamicItems);
            return items;
        }
        return null;
    };
    
    const categoryProps = {
        PaperProps: {
            style: {
                maxHeight: '240px'
            },
        }
    };

    return (
        <FormControl variant="standard" style={{ minWidth: '340px' }}>
            <InputLabel id="error-category-label">Category</InputLabel>
            <Select
                labelId="error-category-label"
                aria-labelledby="error-category-label"
                value={value ?? ''}
                onChange={onCategoryChange}
                disabled={disabled}
                MenuProps={categoryProps}
                data-cy="error-category"
            >
                {getCategoryOptions()}
            </Select>
            {!value?.length && displayHelpText &&
            <FormHelperText>Leaving blank will retain existing category if one was previously set.</FormHelperText>
            }
        </FormControl>
    );
};

export default ErrorCategoryField;